import * as React from 'react';

import { Slug } from '@fnv-core/utils';
import { FormControlProps } from '../interfaces/FormControlProps';

import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { PropertyHelpers } from '../helpers/PropertyHelpers';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import { InputState } from './Input';
import { LabelAndPopover } from './components/label-and-popover';

class PasswordInput extends React.Component<FormControlProps, InputState> {
    constructor(props: FormControlProps) {
        super(props);
        this.state = {
            dataSourceCounter: 0,
            timer: undefined,
            isLoading: false,
            isButtonClicked: false,
            isErrorLoading : false,
            hasFocus: false
        };
    }

    render() {
        const inputProperties = {
            // Input properties has everything needed to deal with manual input
            // It will load related data when a datasource is set
            ...FormControlHelpers.inputProperties(this)
        };

        return (
            <div className={FormStylingHelpers.getFormGroupStyle(this.props) + ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + '-password-form-group'}>
                <LabelAndPopover 
                    fieldId={PropertyHelpers.getFieldID(this.props)} 
                    label={FormLabelHelpers.getFieldLabel(this)}
                    explanation={this.props.formFieldDefinition.explanation}
                    hasPopover={this.props.formFieldDefinition.hasPopover}                    
                ></LabelAndPopover>
                <div className="input-group">
                    <input
                        {...inputProperties}
                        type="password"
                        className={FormStylingHelpers.getInputStyle(this)}
                    />
                    <div className="input-group-append form-control--is-valid-indicator">
                        <div className="input-group-text">
                            <span className="icon icon-checkmark" />
                        </div>
                    </div>
                    {FormControlHelpers.invalidFeedbackComponent(this)}
                </div>
            </div>
        );
    }
}

export { PasswordInput };
